import { BaseMapper } from '@ps/utils';
import { NotificationItem } from '@ps/notification-models';

import { NotificationDto } from '../dtos/notification.dto';

export class NotificationMapper extends BaseMapper<
  NotificationDto,
  NotificationItem
> {
  public fromDto(notificationDto: NotificationDto): NotificationItem {
    return {
      notificationId: notificationDto.notificationId,
      templateId: notificationDto.templateId,
      type: notificationDto.type,
      sender: {
        kind: notificationDto.sender.kind,
        userId: notificationDto.sender.userId,
        name: notificationDto.sender.name,
      },
      content: notificationDto.content,
      data: notificationDto.data,
      viewed: notificationDto.viewed,
      viewedAt: notificationDto.viewedAt,
      createdAt: notificationDto.createdAt,
    };
  }
}
